<template>
    <div class="container-fluid">
        <div class="row">   
            <div class="container">   
            <ControlsHeader></ControlsHeader>

                <div class="container">
                    <hr class="custom-100">
                    <div class="container">
                        <div class="row mt-4 mb-4">

                            <div style="background-color:white; box-shadow: 1px 2px 5px 0px rgba(150,150,150,0.63);" class="col-4 htres pt-2 pb-2">
                                <h2 class="mt-2"><strong>${{arriendoexchange(acommodation.arriendo)}} p/mes</strong></h2>
                                <hr class="custom-100 mt-4 mb-4">
                                <a href="#" class="btn  btn-block btn-success">Solicitar Visita</a>
                              
                                 
                                <hr class="custom-100 mt-4 mb-4">
                                
                                
                                <div class="row mt-4 mb-4">
                                  <div class="col-12">
                                    <HotelDatePicker  :disabledDates='acommodation.reservations'></HotelDatePicker>
                                  </div> 
                                  
                                    <!-- <div class="col-6">
                                        <h5>Desde</h5>
                                          <v-date-picker
                                            mode='single'
                                            v-model='reserva.desde'
                                            :disabled-dates='[
                                            {
                                              start: new Date(2019, 10, 4),
                                              end: new Date(2019, 10, 6)
                                            },
                                            {
                                              start: new Date(2018, 11, 8),
                                              end: new Date(2019, 11, 10)
                                            }
                                          ]'
                                            :min-date='new Date()'>
                                          </v-date-picker>
                                    </div> -->
                                    <!-- <div class="col-6">
                                        <h5>Hasta</h5>
                                          <v-date-picker
                                            mode='single'
                                            v-model='reserva.hasta'
                                            :disabled-dates='fechas_bloqueadas'
                                            :min-date='new Date()'
                                            >
                                          </v-date-picker>
                                    </div>  -->
                                </div>
                                <div class="row mt-4 mb-4">
                                    <div class="col-6">
                                        <h5>Nº Huéspedes</h5>
                                        <input v-model="reserva.nhuespedes" class="form-control" type="number">
                                    </div>
                                    <div class="col-6">

                                    </div>
                                </div>
  
                                <hr class="custom-100 mb-2"> 
                                <div class="row mt-4 mb-2">
                                    <div class="col-6">
                                        <a href="javascript:void(0)" class="btn btn-primary btn-block">
                                          Simular tu estadía
                                        </a>
                                    </div>
                                    <div class="col-6">
                                       <a href="javascript:void(0)" v-b-modal.modal-pago class="btn btn-primary btn-block">
                                           Reservar
                                       </a>
                                    </div>
                                    <b-modal id="modal-pago" 
                                    centered 
                                    size="xl" 
                                    header-border-variant="light"
                                    footer-border-variant="light"
                                    hide-footer
                                    hide-header
                                    @show="resetStep"
                                    >
                                    <form-wizard  :start-index.sync="stepIndex"  title="" subtitle="" color="#662483" shape="hidden">
                                        <tab-content title="paso 1">
                                          <div style="margin-top:-5%;" class="container">
                                            <div class="row">
                                              <div class="col-12">
                                                <h2>Residencias estudiantes</h2>
                                              </div>
                                            </div>  
                                            <div class="row">
                                              <div class="col-12">
                                              <label class="mr-2">Apartamentos</label>  
                                              <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
                                              <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
                                              <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
                                              <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />
                                              <font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" />                                              
                                              </div>
                                            </div>
                                            <div class="row mt-2">
                                              <div class="col-4">
                                                <Carousel :idAlojamiento="this.$route.params.idalojamiento"></Carousel> 
                                              </div>
                                              <div class="col-4">
                                                <div style="background-color: #F7F7F7;">
                                                 <label class="mb-3 mt-4 ml-4"><h5>Pago por reserva</h5></label>
                                                 <div class="row mt-4">
                                                    <div class="col-5 ml-4">
                                                      Primer mes
                                                    </div>
                                                    <div class="col-5 ml-4">
                                                      $21.861
                                                    </div>
                                                 </div>
                                                 <div class="row mb-4">
                                                    <div class="col-5 ml-4">
                                                      <label style="font-size:12px;">Cargo por servicio:</label>
                                                    </div>
                                                    <div class="col-5 ml-4">
                                                      $18.768
                                                    </div>
                                                 </div> 
                                                 <div style="border-top:1px" class="row mt-4 pb-3">
                                                    <div class="col-6 ml-4">
                                                      Total por reserva
                                                    </div>
                                                    <div class="col-4 ml-4">
                                                      ${{ammount}}
                                                    </div>
                                                 </div>                                                                                                 
                                                </div>
                                              </div>
                                              <div class="col-4">
                                                <div style="background-color: #F7F7F7;">
                                                 <label class="mb-3 mt-4 ml-4 pb-2"><h5>Pago durante estadía</h5></label>
                                                 <div class="row pb-4">
                                                    <div class="col-12 ml-3">
                                                      <p>
                                                      Deberás pagar directamente al anfitrión,<br>
                                                      (x monto) mensualmente en los primeros<br>
                                                      5 días de cada mes y lo restante del valor<br>
                                                      de alojamiento el último mes.
                                                      </p>
                                                    </div>
                                                 </div>                                                                                                
                                                </div>
                                              </div>
                                            </div>
                                            <hr class="mt-4 mb-4">
                                            <div class="row">
                                              <div class="col-3">
                                                <v-date-picker
                                                  mode='single'
                                                  v-model='reserva.desde'
                                                  :disabled-dates='fechas_bloqueadas'
                                                  :min-date='new Date()'
                                                 >
                                                </v-date-picker>
                                              </div>
                                              <div class="col-3">
                                                <v-date-picker
                                                  mode='single'
                                                  v-model='reserva.hasta'
                                                  :disabled-dates='fechas_bloqueadas'
                                                  :min-date='new Date()'
                                                  >
                                                </v-date-picker>
                                              </div>
                                              <div class="col-3">
                                                <input  v-model="reserva.nhuespedes" placeholder="Nº Huéspedes" class="form-control" type="number">
                                              </div>
                                              <div class="col-3">
                                                  <div class="circular--portrait">
                                                      <img v-bind:src="url+'perfil/'+user.imagen"/>                       
                                                  </div>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div class="col-3">
                                                  <input type="radio" name="tipo_pago" value="parcial" checked="">
                                                  Cargo por servicio + garantía
                                              </div>
                                              <div class="col-3">
                                                  <input type="radio" name="tipo_pago" value="parcial" checked="">
                                                  Pagar estadía completa
                                              </div>
                                              <div class="col-3">
                                                <img src="../assets/1.svg">
                                                Transfer gratuito
                                              </div>
                                              <div class="col-3">
                                                <img src="../assets/1.svg">
                                                Kit bienvenida de regalo!
                                              </div>
                                            </div>                                            
                                            <hr>
                                          </div>

                                        </tab-content>

                                        <tab-content title="paso 2" >
                                          <div style="margin-top:-5%;" class="container">
                                            <div class="row">
                                              <div class="col-12">
                                                <h2>Detalle del pago</h2>
                                              </div>
                                            </div>  
                                            <div class="row">
                                              <div class="col-12">
                                                <span class="float-left">
                                                Cargo por servicio:
                                                </span>
                                                <span class="float-right">
                                                $18.768
                                                </span>
                                              </div>
                                            </div>
                                            <hr class="mt-2">
                                            <div class="row">
                                              <div class="col-12">
                                                <span class="float-left">
                                                Garantía:
                                                </span>
                                                <span class="float-right">
                                                $21.861
                                                </span>
                                              </div>
                                            </div>
                                            <hr class="mt-2">
                                            <div class="row">
                                              <div class="col-12">
                                                <span class="float-left">
                                                Pago por reserva:
                                                </span>
                                                <span class="float-right">
                                                ${{ammount}}
                                                </span>
                                              </div>
                                            </div>
                                            <hr class="mt-2">                                            
                                            <div class="row">
                                              <div class="col-12 mt-5 mb-5">
                                                <center><b>Selecciona un método de pago</b></center>
                                              </div>
                                            </div>  
                                            <div class="row">
                                              <div class="col-1"></div>
                                              <div class="col-2">
                                                <center>
                                                Mercado Pago
                                                </center>
                                              </div>
                                              <div class="col-2">
                                                <a class="btn btn-primary btn-block" :href="urlwebpay">Webpay</a>
                                                <center>
                                                Webpay <br><label style="font-size:13px;">(tarjetas internacionales)</label>
                                                </center>
                                              </div>
                                              <div class="col-2">
                                                <a class="btn btn-primary btn-block" :href="urlwebpay">Webpay</a>
                                                <center>
                                                Webpay<br><label style="font-size:13px;">(tarjetas chilenas)</label>
                                                </center>
                                              </div>
                                              <div class="col-2">
                                                <center>
                                                Paypal<br><label style="font-size:13px;">(tarjetas internacionales)</label>
                                                </center>
                                              </div>
                                              <div class="col-2">
                                                <center>
                                                Transferencia
                                                </center>
                                              </div>       
                                              <div class="col-1"></div>                                       
                                            </div>                                          
                                            <hr class="mt-4">
                                          </div>
                                        </tab-content>

                                        <tab-content title="paso 3">
                                         lorem 3
                                        </tab-content>   


                                      <template slot="footer" slot-scope="props">
                                          <div v-if="stepIndex === 0" class="wizard-footer-left wizard-footer-center-left mt-5 ml-3">       
                                              <input type="checkbox"> Para continuar debes aceptar los términos y condiciones de uso.            
                                          </div>
                                          <div class="wizard-footer-right wizard-footer-center-right">       
                                            <wizard-button 
                                            v-if="stepIndex === 0" @click.native="props.nextTab()"  v-show="!props.isLastStep || props.isLastStep"
                                            class="wizard-footer btn-custom2" 
                                            :style="props.fillButtonStyle">CONTINUAR</wizard-button> 
                                            <wizard-button 
                                            v-if="stepIndex === 1" @click.native="props.prevTab()" 
                                            class="wizard-footer btn-custom2" 
                                            :style="props.fillButtonStyle">VOLVER</wizard-button>                                                                                    
                                          </div>
                                        </template>      

                                    </form-wizard>
                                    </b-modal>                                    
                                </div>                                  
                            </div>
                            <div class="col-8">
                                <Carousel :idAlojamiento="this.$route.params.idalojamiento"></Carousel> 
                            </div>
                        </div>
                        
                    </div>
                    <hr class="custom-100  mb-4"> 
                    <div class="container mb-4">
                        <div class="row">
                            <div class="col-12 htres">
                                <h3 v-if="iso639_1 === 'es'">
                                    {{JSON.parse(acommodation.nombre).es}}
                                </h3>
                                <h3 v-else>
                                    {{JSON.parse(acommodation.nombre).en}}
                                </h3>  
                            </div>
                        </div>
                    </div>
                    <div style="background-color:white; box-shadow: 1px 2px 5px 0px rgba(150,150,150,0.63);" class="container pt-4 pb-2 mb-4">
                        <div class="row justify-content-around mt-2 mb-4">
                            <div class="col-12 col-md-2">
                                <center>
                                <img src="../assets/1.svg">
                                <br>
                                <strong>${{arriendoexchange(acommodation.arriendo)}} p/mes</strong>
                                <br>
                                por mes	
                                </center>	
                            </div>

                            <div class="col-12 col-md-2">
                                <center>
                                <img src="../assets/1.svg">
                                <br>
                                <strong>${{acommodation.gastos_comunes}}</strong>
                                <br>
                                gastos comunes	
                                </center>		
                            </div>

                            <div class="col-12 col-md-2">
                                <center>
                                <img src="../assets/1.svg">
                                <br>
                                <strong>{{acommodation.m2}} m2</strong>
                                <br>
                                superficie
                                </center>		
                            </div>

                            <div class="col-12 col-md-2">
                                <center>
                                <img src="../assets/1.svg">
                                <br>
                                <strong v-if="acommodation.tipo == 'entero'">Casa o departamento</strong>
                                <strong v-else-if="acommodation.tipo == 'privado'">Habitación privada</strong>
                                <strong v-else>Habitación compartida</strong>
                                </center>
                            </div>

                            <div class="col-12 col-md-2">
                                <center>
                                <img src="../assets/1.svg">
                                <br>
                                <strong v-if="acommodation.caracteristicas.metro == 1">Estación de metro cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.paradero == 1">Paradero de micro cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.hospital == 1">Hospital cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.supermercado == 1">Supermercado cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.banco == 1">Banco cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.zona_nocturna == 1">Zona nocturna cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.areas_verdes == 1">Áreas verdes cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.centro_comercial == 1">Centro comercial cerca</strong>
                                <strong v-else-if="acommodation.caracteristicas.centro_civico == 1">Centro civico cerca</strong> 
                                <strong v-else>Gimnasio</strong>
                                </center>
                            </div>
                        </div>
                    </div>              
                    <div class="container mb-4">
                        <div class="row">
                            <div class="col-12 htres">
                                <h3 class="mt-4 mb-4">
                                    Características del alojamiento
                                </h3>

                                <b-card no-body style="background-color:white; box-shadow: 1px 2px 5px 0px rgba(150,150,150,0.63);" class="container pt-4 pb-2 mb-4"> 
                                    <b-tabs  class="container pt-4 pb-2 mb-4 bg-whithe" active-nav-item-class="text-black border-light bg-transparent"
                                   fill  vertical >
                                    <b-tab v-for="pieza in acommodation.pieza" :key="pieza.idpieza">
                                      <template v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la habitación</strong>
                                      </template>                                      
                                      <b-card-text>
                                        <strong v-if="pieza.cama_2_plazas"><img src="../assets/1.svg"> {{pieza.cama_2_plazas}} x Cama 2 plazas<br></strong>
                                        <strong v-if="pieza.bano_compartido"><img src="../assets/1.svg">{{pieza.bano_compartido}} x Baño compartido<br></strong>
                                        <strong v-if="pieza.escritorio"><img src="../assets/1.svg">{{pieza.escritorio}} x Escritorio<br></strong>
                                        <strong v-if="pieza.ac"><img src="../assets/1.svg">{{pieza.ac}} x Aire acondicionado<br></strong>  
                                        <strong v-if="pieza.cama_1_media_plaza"><img src="../assets/1.svg">{{pieza.cama_1_media_plaza}} x Cama 1 1/2 plaza<br></strong>  
                                        <strong v-if="pieza.cama_1_plaza"><img src="../assets/1.svg">{{pieza.cama_1_plaza}} x Cama 1 plaza<br></strong>                                                                              
                                        <strong v-if="pieza.bano_privado"><img src="../assets/1.svg">{{pieza.bano_privado}} x Baño privado<br></strong>   
                                        <strong v-if="pieza.ropa_cama"><img src="../assets/1.svg">{{pieza.ropa_cama}} x Ropa de cama<br></strong>   
                                        <strong v-if="pieza.calefaccion"><img src="../assets/1.svg">{{pieza.calefaccion}} x calefaccion<br></strong>   
                                        <strong v-if="pieza.camarote"><img src="../assets/1.svg">{{pieza.camarote}} x Camarote<br></strong>   
                                        <strong v-if="pieza.velador"><img src="../assets/1.svg">{{pieza.velador}} x Velador<br></strong> 
                                        <strong v-if="pieza.wifi"><img src="../assets/1.svg">{{pieza.wifi}} x Wifi<br></strong>
                                        <strong v-if="pieza.secador"><img src="../assets/1.svg">{{pieza.secador}} x Secador de pelo<br></strong>
                                        <strong v-if="pieza.sofa_cama"><img src="../assets/1.svg">{{pieza.sofa_cama}} x Sofá cama<br></strong>
                                        <strong v-if="pieza.closet"><img src="../assets/1.svg">{{pieza.closet}} x Clóset<br></strong>
                                        <strong v-if="pieza.colgadores"><img src="../assets/1.svg">{{pieza.colgadores}} x Colgadores<br></strong>  
                                        <strong v-if="pieza.ventilador"><img src="../assets/1.svg">{{pieza.ventilador}} x Ventilador<br></strong>  
                                      </b-card-text>
                                    </b-tab>

                                    <b-tab>
                                    <!-- <template v-if="acommodation.tipo == 'entero'" v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la casa o departamento</strong>
                                    </template> 
                                    <template v-else-if="acommodation.tipo == 'privado'" v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la Habitación privada</strong>
                                    </template>
                                    <template v-else v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la Habitación compartida</strong>
                                    </template>   -->
                                    <template v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la casa o departamento</strong>
                                    </template> 
                                      <b-card-text> 
                                        <strong v-if="acommodation.caracteristicas.conserje"><img src="../assets/1.svg">Conserje<br></strong>
                                        <strong v-if="acommodation.caracteristicas.timbre"><img src="../assets/1.svg">Timbre<br></strong>
                                        <strong v-if="acommodation.caracteristicas.bodega"><img src="../assets/1.svg">Bodega<br></strong>
                                        <strong v-if="acommodation.caracteristicas.eprivado"><img src="../assets/1.svg">Estacionamiento privado<br></strong>
                                        <strong v-if="acommodation.caracteristicas.evisita"><img src="../assets/1.svg">Estacionamiento visita<br></strong>
                                        <strong v-if="acommodation.caracteristicas.ebicicleta"><img src="../assets/1.svg">Estacionamiento Bicicleta<br></strong>
                                        <strong v-if="acommodation.caracteristicas.sestar"><img src="../assets/1.svg">Sala estar<br></strong>
                                        <strong v-if="acommodation.caracteristicas.seventos"><img src="../assets/1.svg">Salón de eventos<br></strong>
                                        <strong v-if="acommodation.caracteristicas.jardines"><img src="../assets/1.svg">Jardines<br></strong>
                                        <strong v-if="acommodation.caracteristicas.piscina"><img src="../assets/1.svg">Piscina<br></strong>
                                        <strong v-if="acommodation.caracteristicas.gimnasio"><img src="../assets/1.svg">Gimnasio<br></strong>
                                        <strong v-if="acommodation.caracteristicas.desayuno"><img src="../assets/1.svg">Desayuno<br></strong>
                                        <strong v-if="acommodation.caracteristicas.refrigerador"><img src="../assets/1.svg">Refrigerador<br></strong>
                                        <strong v-if="acommodation.caracteristicas.cocina"><img src="../assets/1.svg">Cocina<br></strong>
                                        <strong v-if="acommodation.caracteristicas.microondas"><img src="../assets/1.svg">Microondas<br></strong>
                                        <strong v-if="acommodation.caracteristicas.parrilla"><img src="../assets/1.svg">Parrilla<br></strong>
                                        <strong v-if="acommodation.caracteristicas.horno"><img src="../assets/1.svg">Horno<br></strong>
                                        <strong v-if="acommodation.caracteristicas.lavadora"><img src="../assets/1.svg">Lavadora<br></strong>
                                        <strong v-if="acommodation.caracteristicas.secadora"><img src="../assets/1.svg">Secadora<br></strong>
                                        <strong v-if="acommodation.caracteristicas.plancha"><img src="../assets/1.svg">Plancha<br></strong>
                                        <strong v-if="acommodation.caracteristicas.limpieza"><img src="../assets/1.svg">Limpieza<br></strong>
                                        <strong v-if="acommodation.caracteristicas.mascotas"><img src="../assets/1.svg">Mascotas<br></strong>
                                      </b-card-text> 
                                    </b-tab>

                                    <b-tab>
                                      <template v-slot:title>
                                        <img src="../assets/1.svg"> <strong>Características de la ubicación</strong>
                                      </template> 
                                      <b-card-text> 
                                        <strong v-if="acommodation.caracteristicas.metro"><img src="../assets/1.svg">Estación de metro<br></strong>
                                        <strong v-if="acommodation.caracteristicas.paradero"><img src="../assets/1.svg">Paradero de micro<br></strong>
                                        <strong v-if="acommodation.caracteristicas.hospital"><img src="../assets/1.svg">Hospital<br></strong>
                                        <strong v-if="acommodation.caracteristicas.supermercado"><img src="../assets/1.svg">Supermercado<br></strong>
                                        <strong v-if="acommodation.caracteristicas.banco"><img src="../assets/1.svg">Banco<br></strong>
                                        <strong v-if="acommodation.caracteristicas.zona_nocturna"><img src="../assets/1.svg">Zona nocturna<br></strong>
                                        <strong v-if="acommodation.caracteristicas.areas_verdes"><img src="../assets/1.svg">Áreas verdes<br></strong>
                                        <strong v-if="acommodation.caracteristicas.centro_comercial"><img src="../assets/1.svg">Centro comercial<br></strong>
                                        <strong v-if="acommodation.caracteristicas.centro_civico"><img src="../assets/1.svg">Centro civico<br></strong>
                                        <strong v-if="acommodation.caracteristicas.gimnasio"><img src="../assets/1.svg">Gimnasio<br></strong>                                    
                                      </b-card-text> 
                                    </b-tab>
                                    </b-tabs>
                                </b-card> 

                                <b-card no-body >
                                  <b-card-header  header-tag="header" class="p-1" role="tab">
                                    <b-button v-if="iso639_1 === 'es'" block href="#" v-b-toggle.reglas variant="info">Reglas generales</b-button>
                                    <b-button v-else block href="#" v-b-toggle.reglas variant="info">General rules</b-button>
                                  </b-card-header>
                                    <b-collapse visible id="reglas" accordion="reglas" role="tabpanel">
                                     <b-card-body class="mb-4 mt-4">
                                        <b-container v-if="iso639_1 === 'es'" fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.rgenerales).es}}
                                        </b-container>
                                        <b-container v-else fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.rgenerales).en}}
                                        </b-container>
                                      </b-card-body>
                                    </b-collapse>
                                </b-card>


                                <b-card no-body >
                                  <b-card-header  header-tag="header" class="p-1" role="tab">
                                    <b-button v-if="iso639_1 === 'es'" block href="#" v-b-toggle.comunes variant="info">Uso de espacios comunes</b-button>
                                    <b-button v-else block href="#" v-b-toggle.comunes variant="info">Use of common spaces</b-button>
                                  </b-card-header>
                                    <b-collapse  id="comunes" accordion="comunes" role="tabpanel">
                                     <b-card-body class="mb-4 mt-4">
                                        <b-container v-if="iso639_1 === 'es'" fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.ecomunes).es}}
                                        </b-container>
                                        <b-container v-else fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.ecomunes).en}}
                                        </b-container>
                                      </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body >
                                  <b-card-header  header-tag="header" class="p-1" role="tab">
                                    <b-button v-if="iso639_1 === 'es'" block href="#" v-b-toggle.cocina variant="info">Uso de la cocina</b-button>
                                    <b-button v-else block href="#" v-b-toggle.cocina variant="info">Kitchen use</b-button>
                                  </b-card-header>
                                    <b-collapse  id="cocina" accordion="cocina" role="tabpanel">
                                     <b-card-body class="mb-4 mt-4">
                                        <b-container v-if="iso639_1 === 'es'" fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.ucocina).es}}
                                        </b-container>
                                        <b-container v-else fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.ucocina).en}}
                                        </b-container>
                                      </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body >
                                  <b-card-header  header-tag="header" class="p-1" role="tab">
                                    <b-button v-if="iso639_1 === 'es'" block href="#" v-b-toggle.alimpieza variant="info">Aseo y limpieza</b-button>
                                    <b-button v-else block href="#" v-b-toggle.alimpieza variant="info">Cleaning</b-button>
                                  </b-card-header>
                                    <b-collapse  id="alimpieza" accordion="alimpieza" role="tabpanel">
                                     <b-card-body class="mb-4 mt-4">
                                        <b-container v-if="iso639_1 === 'es'" fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.alimpieza).es}}
                                        </b-container>
                                        <b-container v-else fluid style="font-weight: bold;">
                                            {{JSON.parse(acommodation.caracteristicas.alimpieza).en}}
                                        </b-container>
                                      </b-card-body>
                                    </b-collapse>
                                </b-card>                                
                            </div>
                        </div>
                    </div>


                    <div class="container mb-4">
                        <div class="row">
                            <div class="col-12 htres">
                                <h3 class="mt-4 mb-4">
                                    Ubicación
                                </h3>

                                <GmapMap
                                  :center="{lat:acommodation.latitud, lng:acommodation.longitud}"
                                   ref="mapRef"
                                  :zoom="16"
                                  map-type-id="roadmap"
                                  style="width: auto; height: 500px"
                                >
                                  <GmapMarker
                                    :position="{lat:acommodation.latitud, lng:acommodation.longitud}"
                                    :clickable="false"
                                    :draggable="false"
                                  /> 
                                  
                                </GmapMap> 


                                                           
                            </div>
                        </div>
                    </div>         


                </div>

            </div>
        </div>    
    </div>
    
</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from "vuex"
import ControlsHeader from '@/components/ControlsHeader.vue'
import Carousel from '@/components/Carousel.vue'
import HotelDatePicker from 'vue-hotel-datepicker'

export default {
  name: 'DetalleAlojamiento',
  data() {
    return {
      fechas_bloqueadas:[],
      ammount: 89770,
      urlwebpay: process.env.VUE_APP_API_URL+'webpay/pay',     
      reserva:{
          desde: null,
          hasta: null,
          nhuespedes: 0
      }, 
     url : process.env.VUE_APP_S3_URL,
     stepIndex: 0,
     acommodation:{
       idalojamiento: 0,
       nombre: '',
       full_name: '',
       direccion: '',
       numero: null,
       ndc: null,
       m2: null,
       habitaciones: '',
       maximo_huespedes: 1,
       tipo: '',
       arriendo: 0,
       gastoinmueble: 0,
       serviciosb: 0,
       limpieza: 0,
       gastos_comunes: 0,
       vdiario: 0,
       caracteristicas:{
        rgenerales: '',
        ecomunes: '',
        ucocina: '',
        alimpieza: '',
        conserje: 0,
        timbre: 0,
        bodega: 0,
        eprivado: 0,
        evisita: 0,
        ebicicleta: 0,
        sestar: 0,
        seventos: 0,
        jardines: 0,
        piscina: 0,
        gimnasio: 0,
        desayuno: 0,
        refrigerador: 0,
        cocina: 0,
        microondas: 0,
        parrilla: 0,
        horno: 0,
        lavadora: 0,
        secadora: 0,
        plancha: 0,
        limpieza: 0,
        mascotas: 0,
        cama2p: 0,
        bcompartido: 0,
        camam: 0,
        cama1p: 0,
        bprivado: 0,
        camarote: 0,
        velador: 0,
        scama: 0,
        closet: 0,
        esilla: 0,
        acondicionado: 0,
        rcama: 0,
        calefaccion: 0,
        wifi: 0,
        secador: 0,
        tv: 0,
        colgadores: 0,
        ventilador: 0,
        metro: 0,
        paradero: 0,
        csalud: 0,
        supermercado: 0,
        banco: 0,
        znocturna: 0,
        averdes: 0,
        comercial: 0,
        civico: 0,
        gimnasioe: 0,
        hombres: 0,
        mujeres: 0,
        ninos: 0,
        pservicio: 0,
        tedad: 0,
        perros: 0,
        gatos: 0,
        omascotas: 0,
        snosotros: '',
        r1: false,
        r2: false,
        r3: false,
        r4: false,
        r5: false
       },  
        pieza:[],
        tipo_moneda: 'es_CLP',
        latitud: 0,
        longitud: 0,
        reservations:[]
      },
     url: process.env.VUE_APP_S3_URL,
     photos: []    
    }
  },   
  components: {
    ControlsHeader,
    Carousel,
    HotelDatePicker
  },
  methods:{
    resetStep(){
      this.stepIndex = 0
    },
     arriendoexchange (arriendo) {
       let arriendoexchange = 0
        if(this.user.moneda){
          arriendoexchange = Number(arriendo) / Number(this.user.moneda)
          arriendoexchange = arriendoexchange.toFixed(2)
        }else{
          arriendoexchange = arriendo
        }
        return arriendoexchange; 
     },
     formatFechas(data){  
        for (var i = 0; i < data.length; i++) {
          var result = new Date(data[i])
          result.setDate(result.getDate() + 1);
          this.fechas_bloqueadas.push(result)
        }       
     }
  },  
  computed:{
       ...mapState(['user', 'language', 'iso639_1'])
  },      
  created () {
		return new Promise(() => {
			axios({url: process.env.VUE_APP_API_URL+'accommodations/getAccomodationFront/'+this.$route.params.idalojamiento, method: 'GET' })
			.then(resp => {
        this.acommodation.idalojamiento = resp.data.accomodation.idalojamiento
        this.acommodation.nombre = resp.data.accomodation.nombre
        this.acommodation.tipo = resp.data.accomodation.tipo

        this.acommodation.full_name = resp.data.accomodation.direccion
        this.acommodation.direccion = resp.data.accomodation.direccion
        this.acommodation.m2 = resp.data.accomodation.m2
        this.acommodation.maximo_huespedes = resp.data.accomodation.maximo_huespedes

        this.acommodation.arriendo = resp.data.accomodation.arriendo

        this.acommodation.caracteristicas.conserje = resp.data.accomodation.conserje
        this.acommodation.caracteristicas.timbre = resp.data.accomodation.timbre
        this.acommodation.caracteristicas.bodega = resp.data.accomodation.bodega
        this.acommodation.caracteristicas.eprivado = resp.data.accomodation.estacionamiento_privado
        this.acommodation.caracteristicas.evisita = resp.data.accomodation.estacionamiento_visita
        this.acommodation.caracteristicas.ebicicleta = resp.data.accomodation.estacionamiento_bicicleta
        this.acommodation.caracteristicas.sestar = resp.data.accomodation.sala_estar
        this.acommodation.caracteristicas.seventos = resp.data.accomodation.sala_eventos
        this.acommodation.caracteristicas.jardines = resp.data.accomodation.jardines       
        this.acommodation.caracteristicas.piscina = resp.data.accomodation.piscina
        this.acommodation.caracteristicas.gimnasio = resp.data.accomodation.gimnasio_interno
        this.acommodation.caracteristicas.desayuno = resp.data.accomodation.desayuno
        this.acommodation.caracteristicas.refrigerador = resp.data.accomodation.refrigerador
        this.acommodation.caracteristicas.cocina = resp.data.accomodation.cocina
        this.acommodation.caracteristicas.microondas = resp.data.accomodation.horno
        this.acommodation.caracteristicas.parrilla = resp.data.accomodation.microondas
        this.acommodation.caracteristicas.horno = resp.data.accomodation.parrilla
        this.acommodation.caracteristicas.lavadora = resp.data.accomodation.lavadora
        this.acommodation.caracteristicas.secadora = resp.data.accomodation.secadora
        this.acommodation.caracteristicas.plancha = resp.data.accomodation.plancha
        this.acommodation.caracteristicas.limpieza = resp.data.accomodation.limpieza
        this.acommodation.caracteristicas.mascotas = resp.data.accomodation.mascotas
        
        this.acommodation.caracteristicas.paradero = resp.data.accomodation.paradero_micro
        this.acommodation.caracteristicas.metro = resp.data.accomodation.estacion_metro
        this.acommodation.caracteristicas.csalud = resp.data.accomodation.hospital
        this.acommodation.caracteristicas.supermercado = resp.data.accomodation.supermercado
        this.acommodation.caracteristicas.banco = resp.data.accomodation.banco
        this.acommodation.caracteristicas.znocturna = resp.data.accomodation.zona_nocturna
        this.acommodation.caracteristicas.averdes = resp.data.accomodation.areas_verdes
        this.acommodation.caracteristicas.comercial = resp.data.accomodation.centro_comercial
        this.acommodation.caracteristicas.civico = resp.data.accomodation.centro_civico
        this.acommodation.caracteristicas.gimnasioe = resp.data.accomodation.gimnasio_externo
        this.acommodation.caracteristicas.hombres = resp.data.accomodation.hombres
        this.acommodation.caracteristicas.mujeres = resp.data.accomodation.mujeres
        this.acommodation.caracteristicas.ninos = resp.data.accomodation.ninos
        this.acommodation.caracteristicas.pservicio = resp.data.accomodation.personal_servicio
        this.acommodation.caracteristicas.tedad = resp.data.accomodation.tercera_edad	
        this.acommodation.caracteristicas.perros = resp.data.accomodation.perros
        this.acommodation.caracteristicas.gatos = resp.data.accomodation.gatos
        this.acommodation.caracteristicas.omascotas = resp.data.accomodation.otras_mascotas

        this.acommodation.caracteristicas.rgenerales = resp.data.accomodation.reglas
        this.acommodation.caracteristicas.snosotros = resp.data.accomodation.sobre_nosotros
        this.acommodation.caracteristicas.ecomunes = resp.data.accomodation.espacios_comunes
        this.acommodation.caracteristicas.ucocina = resp.data.accomodation.uso_cocina
        this.acommodation.caracteristicas.alimpieza = resp.data.accomodation.aseo_limpieza

        this.acommodation.pieza = resp.data.accomodation.rooms
        //this.acommodation.reservations = resp.data.accomodation.reservations
        this.acommodation.reservations = resp.data.fechas
        this.acommodation.latitud = Number(resp.data.accomodation.latitud)
        this.acommodation.longitud = Number(resp.data.accomodation.longitud)
        //console.log(new Date('2018-12-22'))
        this.formatFechas(resp.data.fechas)
			})
    }) 
  }
}
</script>


<style scoped>
.dot {
  height: 25px;
  width: 25px;
   background-color: #F7F7F7;
  border-radius: 50%;
  display: inline-block;
  border: 1px;
  color: #5A287F;
  border-style: solid;
  border-width: 1px;
  border-color:#5A287F;
}
.btn-custom-fixed{
   background-color:#5A287F;
   color:white;
   width: 35px; 
   height: 60px;
   position: absolute;
   left: -50px;
   top: 60px;
}

@media (max-width: 991px) {
  .btn-custom-fixed{
   display: none;
  }
}

.opt-active{
  background-color: #5A287F;
  color: #FFFFFF;
  border-radius: 0;
}

.total{
  background-color: #5A287F;
  position: absolute;
  top:150px;
  width: auto;
}

.card-footer{
    background-color: #5A287F;
    color:white;
}

.recibe{
    background-color: #5A287F;
    color:white;
}

.o-container {
  padding-top: 40px;
  padding-bottom: 40px;
}

.c-field__error {
  font-size: 12px;
  color: #d71149;
}

.c-file-input {
  position: relative;
  display: block;
  height: 200px;
  width: 100%;
  border: 2px dashed #5A287F;
  background-color: #fff;
}

/* line 24, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid,
.c-field--error .c-file-input {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 28, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus {
  background-color: #ffe6e9;
  border-color: #ff566a;
}

/* line 34, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 36px;
  padding-right: 36px;
  line-height: 36px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  word-wrap: break-word;
  z-index: 1;
}

/* line 50, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field {
  position: absolute !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  z-index: -1;
}

/* line 59, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field:focus {
  outline: none;
}

/* line 64, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator {
  position: absolute;
  left: calc(60% - 62px);
  top: 30px;
  height: 100%;
  width: 86px;
  z-index: 0;
}

/* line 73, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator__icon {
  color: #bbb;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
}

/* line 81, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.has-file .c-file-input__indicator__icon {
  color: #d71149;
}

/* line 86, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 36px;
  z-index: 2;
}

.has-file > .c-file-input__remove {
  display: block;
}

/* line 100, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove__icon {
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
       -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
  left: 4px;
  font-size: 20px;
  color: #ff566a;
}

.cortar {    
      white-space: nowrap;
      text-overflow:ellipsis;
      overflow: hidden;
}

.morado{
    background-color: #5A287F;
}
.height50{
   height: 50px; 
}
.avance-circulo.activo{
    background-color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

.avance-circulo{
    color: #94C11F;
    border-style: solid;
    border-width: 1px;
    border-color:#94C11F;
}

  @media (max-width: 768px) {
  .hidden-xs {
    display: none !important;
  }
}

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #5A287F;
  border-color: #5A287F;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 0;
}


.square {
  position: relative;
}

.square label {
  background-color: #fff;
  border: 1px solid #ccc;
  cursor: pointer;
  height: 55px;
  left: 0;
  position: absolute;
  top: 0;
  width: 55px;
}

.square label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.square input[type="checkbox"] {
  visibility: hidden;
}

.square input[type="checkbox"]:checked + label {
  box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
}

.square input[type="checkbox"] + label {
  box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
}

.square input[type="checkbox"]:checked + label:after {
  opacity: 1;
  border-color: #5A287F;
  width: 40px;
  height: 15px;
  top:20px;
}



.square input[type="radio"] {
  visibility: hidden;
}

.square input[type="radio"]:checked + label {
  box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
}

.square input[type="radio"] + label {
  box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
}

.square input[type="radio"]:checked + label:after {
  opacity: 1;
  border-color: #5A287F;
  width: 30px;
  height: 15px;
}



textarea::-webkit-scrollbar {
    width: 0.6em;
}

textarea::-webkit-scrollbar-thumb {
  background-color: #707070;

}

textarea {
  width: calc(100% - 80px);
  height: auto;
  border:none; 
  background-color: transparent;
}

textarea:focus{
 outline: none;
}

textarea::-webkit-scrollbar-button:start:decrement,
textarea::-webkit-scrollbar-button:end:increment  {
height: 10px;
background-color:transparent;
}

textarea::-webkit-scrollbar-thumb:vertical {
height: 10px;
background-color: #666;
border: 1px solid #eee;
border-radius: 16px;
}

.chico{
 border: 1px solid rgba(90, 40, 127, 0.3);
 width: auto;
 height: 55px;
 background-color: white;
 box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
 text-indent: 10px;
}


.grande{
 border: 1px solid rgba(90, 40, 127, 0.3);
 width: auto;
 height: auto;
 background-color: white;
 box-shadow: 2px 3px 5px 0px rgba(153,145,153,1);
 text-indent: 10px;
}

textarea::placeholder  {
  text-align: center;
  vertical-align: middle;
}


.loader{
  position:absolute; 
  top:25%; 
  left:-10%; 
  z-index:500;
}


  @media (max-width: 768px) {
  .loader {
      position:absolute; 
      top:40%; 
      left:0%; 
      z-index:500;
      margin-bottom: 20px;
    }
  }

  .gif{
    top:-120px;    
  }

  @media (max-width: 768px) {
  .gif {
     top:0px; 
    }
  }

  .btn-primary {
    color: #fff;
    background-color: #662483;
    border-color: #662483;
    display: inline-block;
}

.btn {
    display: inline-block;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: .5rem .75rem;
    font-size: 1rem;
    line-height: 1.25;
    transition: all 0.15s ease-in-out;
}

.htres{
    color: #662483;
}


.popover-container /deep/ input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.btn-success {
    background-color: #94C11F;
    border-color: #94C11F;
}

.btn-success:hover {
    background-color: #7ba01a;
    border-color: #729518;
}

.btn-primary {
    background-color: #662483;
    border-color: #662483;
}

.btn-primary:hover {
    background-color: #4f1c65;
    border-color: #47195b;
}

.circular--portrait {
  position: relative;
  width: 90px;
  height: 90px;
  overflow: hidden;
  border-radius: 50%;
  margin: auto;
  border: 1px solid rgba(90, 40, 127, 0.8);
  box-shadow: 1px 2px 4px 0px rgba(90, 40, 127, 0.8);
  top: -12px;
}

.circular--portrait img {
  width: 150%;
  height: auto;
}

</style>





